<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        :rejectDownload="rejectCount"
        @searchByParameter="searchByParameter"
        @exportData="exportData"
        @bulkUpload="bulkUpload"
        @rejectDownload="rejectDownload"
        searchText="Search"
      />
    </portal>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loadCheck"
      infinite-scroll-throttle-delay="400"
      infinite-scroll-distance="10"
    >
      <MdmHeader
        :headers="sectionHeaders"
        :noCheckbox="true"
        :hasColumnPicker="true"
        :maxDisplayColumn="7"
      />
      <div v-if="isLoading" class="paymentloader"></div>
      <div v-else-if="list.length === 0" class="emptydiv">
        <div class="paymentempty"></div>
        <div class="emptytext">{{ $t("MDM_NO_DATA_FOUND") }}</div>
      </div>
      <MdmRow
        v-else
        v-for="(driver, index) in driverList"
        :key="index"
        :data="driver"
        :headers="sectionHeaders"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdmV2 from '@/components/mixins/SharedMdmV2';
import { blacklistStatusList } from '../../../../constants/driver';

export default {
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
  },
  mixins: [SharedMdmV2],
  data() {
    return {
      openSlideleft: false,
      transactionIds: [],
      skipEditPermission: true,
      overrideDefaultSearchParms: true,
    };
  },
  created() {
    this.loadMore();
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
    }),
    driverList() {
      return (
        this.list &&
        this.list.map((driver) => {
          const newObj = {};
          newObj.id = driver.id;
          newObj.mobile_number = driver.mobile_number;
          newObj.driver_name = driver.driver_name;
          newObj.status = driver.status === 1 ? 'Active' : 'Inactive';
          const blacklistObj =
            driver.blacklist_status &&
            this.blacklistStatusList.find(
              val => val.id === driver.blacklist_status,
            );
          newObj.blacklist_status =
            blacklistObj && blacklistObj.name.toLowerCase().concat('ed');
          newObj.license_number = driver.license_number;
          newObj.transporter_name = driver.transporter_name;
          newObj.transporter_ref_id = driver.transporter_ref_id;
          newObj.medical_start_date = '-';
          if (driver.medical_start_date) {
            newObj.medical_start_date = this.$moment(
              String(driver.medical_start_date),
            ).format('MM/DD/YYYY');
          }
          newObj.medical_end_date = '-';
          if (driver.medical_end_date) {
            newObj.medical_end_date = this.$moment(
              String(driver.medical_end_date),
            ).format('MM/DD/YYYY');
          }
          return newObj;
        })
      );
    },
  },
  methods: {},
};
</script>
